CustomTC.define('jquery/core/var/rsingleTag',[],function() {
	// Match a standalone tag
	return (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);
});

